import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { TeamPage } from './pages/TeamPage';
import { HowWeExecutePage } from './pages/HowWeExecutePage';
import { ProjectsPage } from './pages/ProjectsPage';
import { ContactPage } from './pages/ContactPage';
import { CoursesPage } from './pages/CoursesPage';
import { CourseDetailPage } from './pages/CourseDetailPage';
import { VirtualSalesPage } from './pages/VirtualSalesPage';
import { EmployabilitySkillsPage } from './pages/EmployabilitySkillsPage';
import { SmartStartPage } from './pages/SmartStartPage';
import { YouthEngagementPage } from './pages/YouthEngagementPage';
import { ServicesPage } from './pages/ServicesPage';
import { AcademyPage } from './pages/AcademyPage';
import { SocialImpactPage } from './pages/SocialImpactPage';
import { EnrollmentFormPage } from './pages/EnrollmentFormPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="flex flex-col min-h-screen bg-white" data-id="element-2">
        <Navbar data-id="element-3" />
        <Routes data-id="element-4">
          <Route path="/" element={<HomePage data-id="element-6" />} data-id="element-5" />
          <Route path="/aboutus" element={<AboutPage data-id="element-8" />} data-id="element-7" />
          <Route path="/about" element={<AboutPage data-id="element-10" />} data-id="element-9" />
          <Route path="/team" element={<TeamPage data-id="element-12" />} data-id="element-11" />
          <Route path="/approach" element={<HowWeExecutePage data-id="element-14" />} data-id="element-13" />
          <Route path="/how-we-execute" element={<HowWeExecutePage data-id="element-16" />} data-id="element-15" />
          <Route path="/services" element={<ServicesPage data-id="element-18" />} data-id="element-17" />
          <Route path="/academy" element={<AcademyPage data-id="element-20" />} data-id="element-19" />
          <Route path="/courses" element={<CoursesPage data-id="element-22" />} data-id="element-21" />
          <Route path="/courses/executive-assistant" element={<CourseDetailPage data-id="element-24" />} data-id="element-23" />
          <Route path="/courses/virtual-sales" element={<VirtualSalesPage data-id="element-26" />} data-id="element-25" />
          <Route path="/courses/employability-skills" element={<EmployabilitySkillsPage data-id="element-28" />} data-id="element-27" />
          <Route path="/courses/smartstart-onboarding" element={<SmartStartPage data-id="element-30" />} data-id="element-29" />
          <Route path="/socialimpact" element={<SocialImpactPage data-id="element-32" />} data-id="element-31" />
          <Route path="/youth-engagement" element={<YouthEngagementPage data-id="element-34" />} data-id="element-33" />
          <Route path="/projects" element={<ProjectsPage data-id="element-36" />} data-id="element-35" />
          <Route path="/contact" element={<ContactPage data-id="element-38" />} data-id="element-37" />
          <Route path="/enrollment-form" element={<EnrollmentFormPage data-id="element-40" />} data-id="element-39" />
        </Routes>
        <Footer data-id="element-41" />
      </div>
    </BrowserRouter>;
}